<script setup lang="ts"></script>

<template>
  <div class="tickets-selector-panel" />
</template>

<style scoped lang="scss"></style>
